/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BookNotificationConfigurationData } from '../models/book-notification-configuration-data';
import { BookOnlineConfigurationData } from '../models/book-online-configuration-data';
import { BookReason } from '../models/book-reason';
import { ConfigurationData } from '../models/configuration-data';
import { deleteAppointmentNotificationConfigData } from '../fn/configuration/delete-appointment-notification-config-data';
import { DeleteAppointmentNotificationConfigData$Params } from '../fn/configuration/delete-appointment-notification-config-data';
import { deleteOnlineConfigData } from '../fn/configuration/delete-online-config-data';
import { DeleteOnlineConfigData$Params } from '../fn/configuration/delete-online-config-data';
import { deleteOrgConfigData } from '../fn/configuration/delete-org-config-data';
import { DeleteOrgConfigData$Params } from '../fn/configuration/delete-org-config-data';
import { deleteTreatmentNotificationConfigData } from '../fn/configuration/delete-treatment-notification-config-data';
import { DeleteTreatmentNotificationConfigData$Params } from '../fn/configuration/delete-treatment-notification-config-data';
import { getBookNotificationConfigData } from '../fn/configuration/get-book-notification-config-data';
import { GetBookNotificationConfigData$Params } from '../fn/configuration/get-book-notification-config-data';
import { getBookOnlineConfigData } from '../fn/configuration/get-book-online-config-data';
import { GetBookOnlineConfigData$Params } from '../fn/configuration/get-book-online-config-data';
import { getConfigData } from '../fn/configuration/get-config-data';
import { GetConfigData$Params } from '../fn/configuration/get-config-data';
import { getReasonsToExclude } from '../fn/configuration/get-reasons-to-exclude';
import { GetReasonsToExclude$Params } from '../fn/configuration/get-reasons-to-exclude';
import { updateConfigData } from '../fn/configuration/update-config-data';
import { UpdateConfigData$Params } from '../fn/configuration/update-config-data';
import { updateFirmConfigData } from '../fn/configuration/update-firm-config-data';
import { UpdateFirmConfigData$Params } from '../fn/configuration/update-firm-config-data';
import { updateNotificationConfigData } from '../fn/configuration/update-notification-config-data';
import { UpdateNotificationConfigData$Params } from '../fn/configuration/update-notification-config-data';
import { updateOnlineConfigData } from '../fn/configuration/update-online-config-data';
import { UpdateOnlineConfigData$Params } from '../fn/configuration/update-online-config-data';
import { ValidationError } from '../models/validation-error';

@Injectable({ providedIn: 'root' })
export class ConfigurationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateConfigData()` */
  static readonly UpdateConfigDataPath = '/api/configuration/{id}';

  /**
   * Adds/Updates configuration data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateConfigData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateConfigData$Response(params: UpdateConfigData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return updateConfigData(this.http, this.rootUrl, params, context);
  }

  /**
   * Adds/Updates configuration data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateConfigData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateConfigData(params: UpdateConfigData$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.updateConfigData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `updateFirmConfigData()` */
  static readonly UpdateFirmConfigDataPath = '/api/configuration/{id}/firm';

  /**
   * Adds/Updates firm configuration data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFirmConfigData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFirmConfigData$Response(params: UpdateFirmConfigData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return updateFirmConfigData(this.http, this.rootUrl, params, context);
  }

  /**
   * Adds/Updates firm configuration data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFirmConfigData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFirmConfigData(params: UpdateFirmConfigData$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.updateFirmConfigData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `updateOnlineConfigData()` */
  static readonly UpdateOnlineConfigDataPath = '/api/configuration/{id}/book/online';

  /**
   * Adds/Updates online configuration data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOnlineConfigData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOnlineConfigData$Response(params: UpdateOnlineConfigData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return updateOnlineConfigData(this.http, this.rootUrl, params, context);
  }

  /**
   * Adds/Updates online configuration data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOnlineConfigData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOnlineConfigData(params: UpdateOnlineConfigData$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.updateOnlineConfigData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `updateNotificationConfigData()` */
  static readonly UpdateNotificationConfigDataPath = '/api/configuration/{id}/book/notification';

  /**
   * Adds/Updates notification configuration data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateNotificationConfigData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateNotificationConfigData$Response(params: UpdateNotificationConfigData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return updateNotificationConfigData(this.http, this.rootUrl, params, context);
  }

  /**
   * Adds/Updates notification configuration data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateNotificationConfigData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateNotificationConfigData(params: UpdateNotificationConfigData$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.updateNotificationConfigData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `getConfigData()` */
  static readonly GetConfigDataPath = '/api/configuration/type/{type}/{entityId}';

  /**
   * API to select configuration data for given id, type and keys.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfigData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfigData$Response(params: GetConfigData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConfigurationData>>> {
    return getConfigData(this.http, this.rootUrl, params, context);
  }

  /**
   * API to select configuration data for given id, type and keys.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfigData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfigData(params: GetConfigData$Params, context?: HttpContext): Observable<Array<ConfigurationData>> {
    return this.getConfigData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ConfigurationData>>): Array<ConfigurationData> => r.body)
    );
  }

  /** Path part for operation `getReasonsToExclude()` */
  static readonly GetReasonsToExcludePath = '/api/configuration/book/{bookId}/reasons';

  /**
   * API to select reasons for appointments notifications
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReasonsToExclude()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReasonsToExclude$Response(params: GetReasonsToExclude$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BookReason>>> {
    return getReasonsToExclude(this.http, this.rootUrl, params, context);
  }

  /**
   * API to select reasons for appointments notifications
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getReasonsToExclude$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReasonsToExclude(params: GetReasonsToExclude$Params, context?: HttpContext): Observable<Array<BookReason>> {
    return this.getReasonsToExclude$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BookReason>>): Array<BookReason> => r.body)
    );
  }

  /** Path part for operation `getBookOnlineConfigData()` */
  static readonly GetBookOnlineConfigDataPath = '/api/configuration/book/{bookId}/online';

  /**
   * API to select online configuration data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookOnlineConfigData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookOnlineConfigData$Response(params: GetBookOnlineConfigData$Params, context?: HttpContext): Observable<StrictHttpResponse<BookOnlineConfigurationData>> {
    return getBookOnlineConfigData(this.http, this.rootUrl, params, context);
  }

  /**
   * API to select online configuration data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookOnlineConfigData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookOnlineConfigData(params: GetBookOnlineConfigData$Params, context?: HttpContext): Observable<BookOnlineConfigurationData> {
    return this.getBookOnlineConfigData$Response(params, context).pipe(
      map((r: StrictHttpResponse<BookOnlineConfigurationData>): BookOnlineConfigurationData => r.body)
    );
  }

  /** Path part for operation `getBookNotificationConfigData()` */
  static readonly GetBookNotificationConfigDataPath = '/api/configuration/book/{bookId}/notification';

  /**
   * API to select notification configuration data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookNotificationConfigData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookNotificationConfigData$Response(params: GetBookNotificationConfigData$Params, context?: HttpContext): Observable<StrictHttpResponse<BookNotificationConfigurationData>> {
    return getBookNotificationConfigData(this.http, this.rootUrl, params, context);
  }

  /**
   * API to select notification configuration data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookNotificationConfigData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookNotificationConfigData(params: GetBookNotificationConfigData$Params, context?: HttpContext): Observable<BookNotificationConfigurationData> {
    return this.getBookNotificationConfigData$Response(params, context).pipe(
      map((r: StrictHttpResponse<BookNotificationConfigurationData>): BookNotificationConfigurationData => r.body)
    );
  }

  /** Path part for operation `deleteOrgConfigData()` */
  static readonly DeleteOrgConfigDataPath = '/api/configuration/{id}/organization/{keys}';

  /**
   * Delete organization configuration data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOrgConfigData()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOrgConfigData$Response(params: DeleteOrgConfigData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteOrgConfigData(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete organization configuration data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOrgConfigData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOrgConfigData(params: DeleteOrgConfigData$Params, context?: HttpContext): Observable<void> {
    return this.deleteOrgConfigData$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteTreatmentNotificationConfigData()` */
  static readonly DeleteTreatmentNotificationConfigDataPath = '/api/configuration/{id}/department/notification/{keys}';

  /**
   * Delete treatment notification configuration data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTreatmentNotificationConfigData()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTreatmentNotificationConfigData$Response(params: DeleteTreatmentNotificationConfigData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTreatmentNotificationConfigData(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete treatment notification configuration data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTreatmentNotificationConfigData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTreatmentNotificationConfigData(params: DeleteTreatmentNotificationConfigData$Params, context?: HttpContext): Observable<void> {
    return this.deleteTreatmentNotificationConfigData$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteOnlineConfigData()` */
  static readonly DeleteOnlineConfigDataPath = '/api/configuration/{id}/book/online/{keys}';

  /**
   * Delete online configuration data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOnlineConfigData()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOnlineConfigData$Response(params: DeleteOnlineConfigData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteOnlineConfigData(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete online configuration data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOnlineConfigData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOnlineConfigData(params: DeleteOnlineConfigData$Params, context?: HttpContext): Observable<void> {
    return this.deleteOnlineConfigData$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteAppointmentNotificationConfigData()` */
  static readonly DeleteAppointmentNotificationConfigDataPath = '/api/configuration/{id}/book/notification/{keys}';

  /**
   * Delete notification configuration data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAppointmentNotificationConfigData()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAppointmentNotificationConfigData$Response(params: DeleteAppointmentNotificationConfigData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAppointmentNotificationConfigData(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete notification configuration data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAppointmentNotificationConfigData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAppointmentNotificationConfigData(params: DeleteAppointmentNotificationConfigData$Params, context?: HttpContext): Observable<void> {
    return this.deleteAppointmentNotificationConfigData$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
